import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './NavigationDropDown.styles'

const NavigationDropDown = ({
  items,
  selectedId,
  onSelect = () => {},
  locked,
  ...rest
}) => {
  const [open, setOpen] = useState(false)

  const handleTabClick = (id) => {
    setOpen(!open)
    onSelect(id)
  }

  const toggleDropDown = () => {
    if (!locked) {
      setOpen(!open)
    }
  }

  return (
    <Styled.NavigationDropDownComponent { ...rest }>
      {items.length > 0 && (
        <nav className='navigation-tabs-topic__nav'>
          <ul className='navigation-tabs-topic__toggle js-navigation-tabs-toggle row'>
            <li className='navigation-tabs-topic__tab'>
              <a
                role='button'
                className={ `${ locked ? 'locked' : '' }` }
                onClick={ () => toggleDropDown() }>
                <span>
                  {items.find((item) => item.id === selectedId)?.label}
                </span>
              </a>
            </li>
          </ul>
          <ul
            className='navigation-tabs-topic__list row js-navigation-tabs-list'
            id='tab-content-0'
            role='tablist'
            style={{ display: open ? `block` : `none` }}>
            {items.map((item, idx) => (
              <li
                className={ `navigation-tabs-topic__tab${
                  selectedId === item.id ? ' active' : ''
                }` }
                key={ idx }>
                <a
                  className='navigation-tabs-topic__toggle-tab'
                  href={ `#tab-content-${ idx }` }
                  role='tab'
                  data-event='navigation-tab'
                  data-evalue={ `tab_${ item.id.toLowerCase() }` }
                  onClick={ () => handleTabClick(item.id) }>
                  <span>{item.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </Styled.NavigationDropDownComponent>
  )
}

NavigationDropDown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func,
}

export default NavigationDropDown
